import { withStyles, WithStyles, StyleRulesCallback, Theme } from '@material-ui/core';
import * as React from 'react';
import { pure } from 'recompose';
import { required, Validator, isNumberLowerAs, maxYearsOld } from '../../../shared/validation';
import FormTextField from '../../../components/FormTextField';
import { Typography } from '@material-ui/core';
import { Field } from 'redux-form';
import { BpM } from '../../../shared/brakepoints';
import Translator from '../../../components/Translator';
import { defaultMemoize } from 'reselect';
import FormDateField from 'components/FormDateField';
import FormSelectField from 'components/FormSelectField';

type CssClasses = 'fieldContainer' | 'fullRow';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  fieldContainer: {
    display: 'flex',
    flexFlow: 'column',
    '& > *': {
      flex: '0 0 100%',
    },
    [BpM()]: {
      display: 'flex',
      margin: '0px -5px 0px',
      width: '750px',
      flexFlow: 'row wrap',
      '& > *': {
        flex: '0 0 320px',
        paddingLeft: '5px',
        paddingRight: '5px',
        maxWidth: '320px',
      },
    },
  },
  fullRow: {
    flex: '0 0 100%',
    maxWidth: '100%',
  },
});

interface Props {}

class HuesgesVehicleFormData extends React.Component<Props & WithStyles<CssClasses>> {
  private translatedRequire = defaultMemoize((translation: string) => {
    return required(translation);
  });
  private translatedIsNumberLowerAs = defaultMemoize((translation: string) => {
    return isNumberLowerAs(translation, 200000);
  });

  private translateVehicleTooOld = defaultMemoize((requiredMessage: string, expiryMessage: string) => {
    return [required(requiredMessage), maxYearsOld(expiryMessage, 25)];
  });

  private justRequired = defaultMemoize((requiredValidator: Validator) => {
    return [requiredValidator];
  });

  private requireNumber = defaultMemoize((isNumberValidator: Validator) => {
    return [isNumberValidator];
  });

  private requireNumberLowerAs = defaultMemoize((isNumberValidator: Validator) => {
    return [isNumberValidator];
  });

  render() {
    let { classes } = this.props;
    return (
      <Translator>
        {translate => {
          const req = this.translatedRequire(translate('missing'));
          const num = this.translatedIsNumberLowerAs(translate('inspectionVehicleMileageTooHigh'));
          const justRequired = this.justRequired(req);
          const requiredNumber = this.requireNumber(num);
          const requiredNumberLowerAs = this.requireNumberLowerAs(num);
          const requireMaxYearsOld = this.translateVehicleTooOld(
            translate('missing'),
            translate('inspectionVehicleRegistrationDateTooOld')
          );
          return (
            <>
              <Typography variant={'h6'}>{translate('inspectionVehicleDataTitle')}</Typography>
              <div className={classes.fieldContainer}>
                <Field
                  name="vehicleVin"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={'FIN'}
                  fullWidth={true}
                />
                <Field
                  name="vehicleLicensePlate"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={'Kennzeichen'}
                  fullWidth={true}
                />
                <Field
                  name="vehicleManufacturer"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={'Hersteller'}
                  fullWidth={true}
                />
                <Field
                  name="vehicleModel"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={'Modell'}
                  fullWidth={true}
                />
                <Field
                  name="vehicleMileage"
                  requireMark
                  component={FormTextField}
                  validate={requiredNumberLowerAs}
                  label={'Laufleistung'}
                  fullWidth={true}
                />
                <Field
                  name="vehicleRegistrationDate"
                  requireMark
                  component={FormDateField}
                  validate={requireMaxYearsOld}
                  label={'Erstzulassung'}
                  fullWidth={true}
                />

                <Field
                  name="vehicleInsuranceType"
                  requireMark
                  component={FormSelectField}
                  validate={justRequired}
                  label={'Versicherungsart'}
                  fullWidth={true}
                  options={[
                    { value: '0', text: 'Haftpflicht' },
                    { value: '1', text: 'Teilkasko' },
                    { value: '2', text: 'Vollkasko' },
                  ]}
                />

                <Field
                  name="vehicleInsuranceDeductible"
                  requireMark
                  component={FormTextField}
                  validate={requiredNumber}
                  label={'Selbstbeteiligung'}
                  fullWidth={true}
                />
              </div>
            </>
          );
        }}
      </Translator>
    );
  }
}

export default pure(withStyles(styles)(HuesgesVehicleFormData));



// WEBPACK FOOTER //
// ./src/routes/inspection/container/HuesgesVehicleFormData.tsx